import React from 'react';

import {
  startSetUser,
  updateUser,
  addUserListener,
} from 'store/actions/userActions.js';
import { db, firebase } from 'firebase/fbConfig.js';

// Get Users for Users Panel
export function listenToThreadsForUser(store, uid) {
  return db
    .collection('threads')
    .where('parties', 'array-contains', uid)
    .onSnapshot((snapshot) => {
      snapshot.docChanges().forEach((change) => {
        const data = change.doc.data();
        const id = change.doc.id;
        switch (change.type) {
          case 'added':
            store.dispatch(addThread(id, data));
            store.dispatch(
              addUserListener(listenToMessagesForThread(store, uid, id))
            );
            store.dispatch(
              addUserListener(listenToInvitationsForThread(store, uid, id))
            );
            break;
          case 'modified':
            store.dispatch(modifyThread(id, data));
            break;
          case 'removed':
            store.dispatch(removeThread(id));
            break;
        }
      });
    });
}

export function listenToMessagesForThread(store, uid, tid) {
  return db
    .collection('threads')
    .doc(tid)
    .collection('messages')
    .onSnapshot((snapshot) => {
      snapshot.docChanges().forEach((change) => {
        const data = change.doc.data();
        const id = change.doc.id;
        switch (change.type) {
          case 'added':
            store.dispatch(addMessage(tid, data));
            break;
          default:
            console.warn('Unsupported message operation:', change.type);
        }
      });
    });
}

export function listenToInvitationsForThread(store, uid, tid) {
  return db
    .collection('threads')
    .doc(tid)
    .collection('invitations')
    .onSnapshot((snapshot) => {
      snapshot.docChanges().forEach((change) => {
        const data = change.doc.data();
        const id = change.doc.id;
        switch (change.type) {
          case 'added':
          case 'modified':
            store.dispatch(setInvitation(tid, id, data));
            break;
          case 'removed':
            store.dispatch(removeInvitation(tid, id));
            break;
          default:
            console.warn('Unsupported message operation:', change.type);
        }
      });
    });
}

export function startCreateThread(thread, message, uid) {
  console.log('startCreateThread', thread, message);
  return (dispatch) => {
    thread = { createdAt: new Date(), ...thread };
    return db
      .collection('threads')
      .add(thread)
      .then((doc) => {
        console.log('startCreateThread', doc.id);
        dispatch(
          updateCurrentThread({ ...thread, tid: doc.id, documents: [] }, true)
        );
        if (message) {
          let messageDoc = { createdAt: new Date(), message, uid };
          return db
            .collection('threads')
            .doc(doc.id)
            .collection('messages')
            .add(messageDoc)
            .then(() => doc.id);
        } else {
          return Promise.resolve(doc.id);
        }
      });
  };
}

export function startArchiveThread(tid) {
  return startModifyThread(tid, { archived: true });
}

export function startArchiveThreadsForCase(cid) {
  return (dispatch) => {
    const results = [];
    db.collection('threads')
      .where('cid', '==', cid)
      .get()
      .then((snapshot) =>
        snapshot.forEach((thread) => {
          results.push(thread.ref.update({ archived: true }));
        })
      )
      .then(() => Promise.all(results));
  };
}

export function startModifyThread(tid, data) {
  return (dispatch) => {
    return db.collection('threads').doc(tid).update(data);
  };
}

export function startAddMessage(tid, data) {
  console.log(data);
  return (dispatch) => {
    let messageDoc = { createdAt: new Date(), ...data };
    return db.collection('threads').doc(tid).collection('messages').add(messageDoc);
  };
}

export function startInvitation(tid, email, data) {
  return (dispatch) => {
    let invitationDoc = { tid, email, createdAt: new Date(), ...data };
    return db
      .collection('threads')
      .doc(tid)
      .collection('invitations')
      .doc(email)
      .set(invitationDoc);
  };
}

export function updateCurrentThread(data, replace) {
  return {
    type: 'THREADS_UPDATE_CURRENT',
    data,
    replace,
  };
}

export function addThread(id, data) {
  return {
    type: 'THREADS_ADD',
    data,
    id,
  };
}

export function modifyThread(id, data) {
  return {
    type: 'THREADS_MODIFY',
    data,
    id,
  };
}

export function removeThread(id) {
  return {
    type: 'THREADS_REMOVE',
    id,
  };
}

export function setCurrentThread(id) {
  return {
    type: 'THREADS_SET_CURRENT',
    id,
  };
}

export function addMessage(id, data) {
  return {
    type: 'THREADS_ADD_MESSAGE',
    id,
    data,
  };
}

export function setInvitation(id, email, data) {
  return {
    type: 'THREADS_SET_INVITATION',
    id,
    email,
    data,
  };
}

export function removeInvitation(id, email) {
  return {
    type: 'THREADS_REMOVE_INVITATION',
    id,
    email,
  };
}

export function setThreadDocument(id, fileNo, data) {
  return {
    type: 'THREADS_SET_DOCUMENT',
    id,
    fileNo,
    data,
  };
}
